import { useEffect, useState } from 'react';

export function useCountdown(deadlineMs: number | null | undefined, active = true) {
  const [remainingMs, setRemaining] = useState(() => Math.max(0, Number(deadlineMs ?? 0) - Date.now()));
  useEffect(() => {
    if (!active || !deadlineMs) {
      setRemaining(Math.max(0, Number(deadlineMs ?? 0) - Date.now()));
      return;
    }
    const update = () => setRemaining(Math.max(0, deadlineMs - Date.now()));
    update();
    const interval = window.setInterval(update, 250);
    return () => window.clearInterval(interval);
  }, [active, deadlineMs]);
  return remainingMs;
}
